import * as PIXI from "pixi.js-legacy";
import events from "../events/EventsObservable";
import {WALLET_EVENTS} from "../wallet/Wallet";
import {CONFIG_PARAMS} from "../system/SystemConfig";
import SystemConfig from "../system/SystemConfig";
import Wallet from "../wallet/Wallet";
import IInfoPages from "../engine/IInfoPages";
import {injectable} from "inversify";

@injectable()
export default class TouchZoneBase {
    config: SystemConfig;
    layers: any;
    slots: any;
    infoPages: IInfoPages;
    wallet: Wallet;
    factory: any;

    gameset: object;
    resSymbols: Array<any>;
    zones: Array<PIXI.Graphics>;
    factorOrder: number;
    creditBet: number;

    factorOnSymbols: Array<any>;

    winFactorSprite: PIXI.Sprite;
    winFactorFrame: PIXI.Sprite;
    winFactorNumbers: PIXI.Sprite;

    constructor (
        config: SystemConfig,
        layers: any,
        slots: any,
        wallet: Wallet,
        symbols: any,
        gameset: any
    ) {
        this.config = config;
        this.layers = layers;
        this.slots = slots;
        this.wallet = wallet;
        this.factory = symbols;

        this.gameset = gameset;
        this.resSymbols = this.slots.getResultSymbols();
        this.zones = [];
        this.factorOrder = -1;

        this.factorOnSymbols = [];

        this.initWinFrames();
        this.initZones();

        events.subscribe(WALLET_EVENTS.WALLET_ON_SET_BET, () => this.updateBet());
    }

    /**
     *   gameset['game']['layers'][
     *     'black',    - black layer to darken other symbols when clicked
     *      'touchZone' - zones are added here
     *   ];
     *   gameset['game']['symbolModel']['touchZone']: {
     *       width :    - width of the touch zone, center aligned with the symbol
     *       height :   - height of the touch zone, center aligned with the symbol
     *       reels :    - array of the LENGTH defined by the reel COLUMNS COUNT, values [left|right], sets to what side is the frame shifted
     *       table :    - name of the winFactor frame image
     *       numbers :  - name of the winFactor numbers image
     *       font :     - name of the font used
     *       factors :  - amount of non-zero factors
     *   }
     *
     *  HOW TO USE TOUCHZONE:
     *  1. Set all gameset fields ^^ in gameset.js
     *  2. Create layers touchZone and winFactors and add them to gameset
     *  3. Rewrite drawFrame() function. use shiftSprite to position elements (don't forget both orientations!).
     *  4. Access elements using:
     *          -   this.winFactorFrame
     *          -   this.winFactorNumbers
     *          -   this.winFactorSprite
     *          -   this.factorOnSymbols[]
     *  5. When you start spinning and when the round ends use zonesOn(), zonesOff() to disable winFactors during spinning
     *
     */

    // Add all sprites to a invisible layer.
    initWinFrames() {
        this.layers.winFactors.alpha = 0;
        let style: PIXI.IBitmapTextStyle = {
            fontName: this.gameset['game']['symbolModel']['touchZone'].font,
            fontSize: 80,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        };
        this.winFactorFrame = new PIXI.Sprite(PIXI.Texture.from(this.gameset['game']['symbolModel']['touchZone'].table));
        this.winFactorFrame.anchor.set(0.5,0.5);
        this.layers.winFactors.addChild(this.winFactorFrame);

        this.winFactorNumbers = new PIXI.Sprite(PIXI.Texture.from(this.gameset['game']['symbolModel']['touchZone'].numbers));
        this.winFactorNumbers.anchor.set(0.5,0.5);
        this.layers.winFactors.addChild(this.winFactorNumbers);
        this.winFactorSprite = this.factory.createByIndex(0,{});
        this.winFactorSprite.anchor.set(0.5,0.5);
        this.layers.winFactors.addChild(this.winFactorSprite);

        for (let i = 0; i < this.gameset['game']['symbolModel']['touchZone'].factors; i++) {
            let factor = new PIXI.BitmapText("", style);
            // @ts-ignore
            factor.anchor.set(1.0,0.5);
            this.factorOnSymbols.push(factor);
            this.layers.winFactors.addChild(factor);
        }
    }

    // Add Invisible Sprite.Rectangles above the symbols on canvas.
    initZones() {
        let reels = this.gameset['game']['symbolModel']['touchZone'].reels;
        let rows = this.gameset['game']['symbolModel'].matrixRow;
        let n = 0; // order on reels, 0 - 14
        for (let symbol of this.resSymbols) {
            this.createHandler(this.createSprite(symbol, n, reels[Math.floor(n++/rows)]));
        }
    }

    // Create the rectangles, set their properties.
    createSprite(symbol: any, n: number, orientation: string = "left") {
        let zone =  new PIXI.Graphics();
        let width = this.gameset['game']['symbolModel']['touchZone'].width;
        let height = this.gameset['game']['symbolModel']['touchZone'].height;
        zone.beginFill(0xFFFFFF);
        zone.lineStyle(0,0x000000, 1);
        zone.drawRect(symbol.x,symbol.y, width, height);
        zone.endFill();
        zone.pivot.x = width/2;
        zone.pivot.y = height/2;
        zone.alpha = 0;
        zone.interactive = true;
        zone.buttonMode = true;
        // @ts-ignore
        zone.order = n;
        // @ts-ignore
        zone.orientation = orientation;
        this.zones.push(zone);
        this.layers.touchZone.addChild(zone);
        return zone;
    }

    // Called on bet change. Change the text of BitmapTexts stored in this.factorOnSymbols
    updateBet() {
        if (this.factorOrder !== -1) {
            this.creditBet = this.wallet.getCreditBet();
            let factors = this.getSymbolFactor(this.resSymbols[this.factorOrder].name).factors;
            let i = 0;
            for (let factor of this.factorOnSymbols) {
                factor.text = factors[factors.length-i++-1]*this.creditBet + "";
            }
        }
    }

    // returns the factors of a symbol given by name
    getSymbolFactor(name: string) {
        return this.config.get(CONFIG_PARAMS.SYMBOL_DEFINITION).find(symbols => symbols.name === name);
    };

    // Create the onpointerdown handler, call drawFrame that repositions the winFrame
    createHandler(zone: PIXI.Graphics) {

        // @ts-ignore
        zone.on("pointerdown", () => {
            // @ts-ignore
            this.factorOrder = zone.order;
            this.onPointerDown();
            this.resSymbols = this.slots.getResultSymbols();
            createjs.Tween.removeTweens(this.layers.winFactors);
            // @ts-ignore
            this.drawFrame(this.resSymbols[zone.order], zone.orientation);
        });


        // @ts-ignore
        zone.on("pointerup", () => {
            this.onPointerUp();
            this.factorOrder = -1;
            this.hide();
        });

        // @ts-ignore
        zone.on("pointerupoutside", () => {
            this.onPointerUp();
            this.factorOrder = -1;
            this.hide();
        });
    }

    // Set new position of a sprite. You can set an offset
    shiftSprite(sprite: PIXI.Sprite, x: number, y: number , shiftX: number = 0, shiftY: number = 0) {
        sprite.position.set(x + shiftX, y + shiftY);
    }

    // All zones (invisible rectangles) are set inactive
    zonesOff() {
        for (let zone of this.zones) {
            zone.buttonMode = false;
            zone.interactive = false;
        }
    }

    // All zones (invisible rectangles) are set active
    zonesOn() {
        for (let zone of this.zones) {
            zone.buttonMode = true;
            zone.interactive = true;
        }
    }

    // Set the layer alpha to 0,
    hide() {
        createjs.Tween.get(this.layers.winFactors).to({
            alpha: 0
        }, 250, createjs.Ease.linear);
    }

    // to override
    onPointerUp() {

    }

    // to override
    onPointerDown() {

    }


    // Here you change the position of winFrame elements
    // Called on every [symbol|zone] click.
    // to override
    drawFrame(symbol: any, orientation: string) {
        /*
        if (this.madmax.modules['info'].isHided) {

            this.creditBet = this.services.wallet.getCreditBet();

            this.layers.winFactors.alpha = 1;

            if (orientation == "left")
                this.shiftSprite(this.winFactorFrame,symbol.x, symbol.y , -70);
            else
                this.shiftSprite(this.winFactorFrame,symbol.x, symbol.y , +70);

            this.winFactorSprite.texture = new PIXI.Texture.from(symbol.name + ".png");
            this.winFactorSprite.position.set(symbol.x, symbol.y);

            if (orientation == "left")
                this.shiftSprite(this.winFactorNumbers,symbol.x, symbol.y , -190);
            else
                this.shiftSprite(this.winFactorNumbers,symbol.x, symbol.y , +120);


            this.factorOnSymbol.text = this.getSymbolFactor(symbol.name).factors[4]*this.creditBet + "";
            this.factorOnSymbol2.text = this.getSymbolFactor(symbol.name).factors[3]*this.creditBet + "";
            this.factorOnSymbol3.text = this.getSymbolFactor(symbol.name).factors[2]*this.creditBet + "";


            this.factorOnSymbol.anchor.set(0.5,0.5);
            if (orientation == "left")
                this.shiftSprite(this.factorOnSymbol,symbol.x, symbol.y , -130, -68);
            else
                this.shiftSprite(this.factorOnSymbol,symbol.x, symbol.y , +180, -68);

            if (orientation == "left")
                this.shiftSprite(this.factorOnSymbol2,symbol.x, symbol.y , -130, -26);
            else
                this.shiftSprite(this.factorOnSymbol2,symbol.x, symbol.y , +180, -26);

            if (orientation == "left")
                this.shiftSprite(this.factorOnSymbol3,symbol.x, symbol.y , -130, +13);
            else
                this.shiftSprite(this.factorOnSymbol3,symbol.x, symbol.y , +180, +13);
        }
        */
    }
}
